"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillsDetection = void 0;
var csod = require("player-core");
var React = require("react");
var PredictiveSearch_1 = require("../PredictiveSearch/PredictiveSearch");
var player_tag_1 = require("player-tag");
var mapping_1 = require("../../mapping");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
var GridCol_1 = require("player-layout-controls/controls/GridCol");
var Panel_1 = require("player-layout-controls/controls/Panel");
var Text_1 = require("player-common-controls/controls/Text/Text");
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader/SectionHeader");
var SkillsDetection = (function (_super) {
    __extends(SkillsDetection, _super);
    function SkillsDetection(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentKeywordQuery: '',
            keywordSearchPredictions: [],
            isLoadingPredictions: false,
            selectedSkills: props.skills,
        };
        _this._handleKeywordQueryChange = _this._handleKeywordQueryChange.bind(_this);
        _this._handleKeywordPredict = _this._handleKeywordPredict.bind(_this);
        _this._handleSkillSelect = _this._handleSkillSelect.bind(_this);
        _this._handleSkillDelete = _this._handleSkillDelete.bind(_this);
        _this._handleSkillSearch = _this._handleSkillSearch.bind(_this);
        _this._emitSkillsChange = _this._emitSkillsChange.bind(_this);
        return _this;
    }
    SkillsDetection.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.skills !== prevProps.skills) {
            this.setState({ selectedSkills: this.props.skills }, function () {
                _this._emitSkillsChange(_this.props.skills);
            });
        }
    };
    SkillsDetection.prototype._handleKeywordQueryChange = function (id, query) {
        this.setState({
            currentKeywordQuery: query
        });
    };
    SkillsDetection.prototype._handleSkillSearch = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._handleKeywordPredict('', query)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SkillsDetection.prototype._handleSkillSelect = function (prediction) {
        var _this = this;
        var newSkill = prediction.value;
        var skillExists = this.state.selectedSkills.some(function (skill) { return skill.id === newSkill.id; });
        if (!skillExists) {
            var updatedSkills_1 = __spreadArrays(this.state.selectedSkills, [newSkill]);
            this.setState({
                selectedSkills: updatedSkills_1,
                currentKeywordQuery: '',
            }, function () {
                _this._emitSkillsChange(updatedSkills_1);
            });
        }
    };
    SkillsDetection.prototype._handleSkillDelete = function (id) {
        var _this = this;
        var updatedSkills = this.state.selectedSkills.filter(function (skill) { return skill.id !== id; });
        this.setState({
            selectedSkills: updatedSkills,
        }, function () {
            _this._emitSkillsChange(updatedSkills);
        });
    };
    SkillsDetection.prototype._emitSkillsChange = function (updatedSkills) {
        if (this.props.onDataChange) {
            this.props.onDataChange(updatedSkills);
        }
    };
    SkillsDetection.prototype._handleKeywordPredict = function (id, query) {
        return __awaiter(this, void 0, void 0, function () {
            var request, predictions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.setState({
                            isLoadingPredictions: true
                        });
                        request = {
                            cultureId: 1,
                            searchText: query,
                        };
                        return [4, mapping_1.getKeywordPredictiveSearchResults(request).then(function (response) {
                                return response.map(function (prediction) { return ({
                                    text: prediction.name,
                                    itemId: prediction.id,
                                    value: prediction,
                                }); });
                            })];
                    case 1:
                        predictions = _a.sent();
                        this.setState({
                            keywordSearchPredictions: __spreadArrays(predictions),
                            isLoadingPredictions: false,
                        });
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error fetching skills:', error_1);
                        this.setState({
                            keywordSearchPredictions: [],
                            isLoadingPredictions: false,
                        });
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    SkillsDetection.prototype.buildPredictiveSearch = function () {
        var _this = this;
        var _a = this.state, currentKeywordQuery = _a.currentKeywordQuery, keywordSearchPredictions = _a.keywordSearchPredictions, isLoadingPredictions = _a.isLoadingPredictions;
        return (React.createElement("div", null,
            React.createElement(Panel_1.Panel, { paddingBottom: "Medium" },
                React.createElement(Text_1.Text, { size: "Large", role: "text", mode: "div", text: csod.locales.get('ATS.AppWorkflow.SkillsDetection.AddSkillsTitle', 'Add additional skills'), weight: "SemiBold", tag: "predictive-search-header" })),
            React.createElement(PredictiveSearch_1.PredictiveSearch, { id: "predictive-skill-search", value: currentKeywordQuery, predictions: keywordSearchPredictions, isLoading: isLoadingPredictions, noPredictionsMessage: csod.locales.get('ATS.AppWorkflow.SkillsDetection.NoMatchFound', 'No matches found'), placeholder: csod.locales.get('ATS.AppWorkflow.SkillsDetection.SearchPlaceholder', 'Search skill'), ariaLabel: csod.locales.get('ATS.AppWorkflow.SkillsDetection.SearchPlaceholder', 'Search skill'), onChange: this._handleKeywordQueryChange, onPredict: this._handleKeywordPredict, onSelect: function (id, prediction) {
                    if (_this._handleSkillSelect) {
                        _this._handleSkillSelect(prediction);
                    }
                    _this.setState({ currentKeywordQuery: '' });
                }, onSearch: function () {
                    if (_this._handleSkillSearch) {
                        _this._handleSkillSearch(_this.state.currentKeywordQuery);
                    }
                    _this.setState({ currentKeywordQuery: '' });
                } })));
    };
    SkillsDetection.prototype.buildAISkillSuggestionTag = function (skill) {
        var _this = this;
        return (React.createElement(Panel_1.Panel, { paddingBottom: "Small" },
            React.createElement(player_tag_1.default, { color: "Primary", backgroundColor: null, key: "skillTag-" + skill.id, text: skill.name, isCloseable: true, tag: "skillTag-" + skill.id, onClick: function () {
                    _this._handleSkillDelete(skill.id);
                }, closeTitle: csod.locales.get('Close'), style: "Filled" })));
    };
    SkillsDetection.prototype.buildApplicationRendererFields = function () {
        var _this = this;
        var _a;
        return (React.createElement(Panel_1.Panel, { tag: "skills-detection-content" },
            React.createElement(GridLayout_1.GridLayout, { gutterHorizontal: 'Xsmall', gutterVertical: 'Medium' },
                React.createElement(GridCol_1.GridCol, { width: '10', widthForSm: '10', key: "predictive-skill-instruction" },
                    React.createElement(Text_1.Text, { text: csod.locales.get('ATS.AppWorkflow.SkillsDetection.Description', 'AI may suggest skills based on your resume. Review, edit, or add skills before submitting your application.'), size: "Medium", weight: 'Normal', mode: "div" }))),
            React.createElement(GridLayout_1.GridLayout, { gutterHorizontal: 'Xsmall', gutterVertical: 'Medium' },
                React.createElement(GridCol_1.GridCol, { width: '6', widthForSm: '6', key: "predictive-skill-search" }, this.buildPredictiveSearch())),
            React.createElement(GridLayout_1.GridLayout, { gutterHorizontal: "Xsmall" }, (_a = this.state.selectedSkills) === null || _a === void 0 ? void 0 : _a.map(function (skill) {
                return (React.createElement(GridCol_1.GridCol, { key: "skillCol-" + skill.id, alignSelf: "true" }, _this.buildAISkillSuggestionTag(skill)));
            }))));
    };
    SkillsDetection.prototype.render = function () {
        return (React.createElement(Panel_1.Panel, { tag: "skills-detection-container" },
            React.createElement(Panel_1.Panel, { paddingBottom: 'Small', tag: 'skills-detection-header-panel' },
                React.createElement(SectionHeader_1.SectionHeader, { size: "H2", text: csod.locales.get('Skills', 'Skills'), tag: "skills-detection-header" })),
            this.buildApplicationRendererFields()));
    };
    return SkillsDetection;
}(React.Component));
exports.SkillsDetection = SkillsDetection;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["SkillsDetection"] = ["CareerSite"];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/SkillsDetection/SkillsDetection.js
// module id = 734
// module chunks = 0